module.exports = __webpack_public_path__ + "static/media/calendar.dd955337.svg";